import Link from 'next/link'
import { clsx } from 'shared/libs/style-merge'

import { Category } from 'modules/Category/model/types'

import { MoreButton } from 'shared/ui/moreButton'

import { useDisclosure } from 'shared/hooks/useDisclosure'

import { ROUTER_PATHS } from 'shared/config/routerPath/RouterPath'

import styles from './SubCategoryList.module.scss'

const visibleSubCategories = 5
interface CategoryListProps {
  children: Category[]
}

export function SubCategoryList({ children }: CategoryListProps) {
  const { isOpen: isExpanded, onToggle: toggleExpand } = useDisclosure(false)

  return (
    <div className={styles.listWrapper}>
      <ul className={clsx(styles.list, { [styles.open]: isExpanded })}>
        {children.map(({ id, name, slug, is_disable, is_hidden }) => {
          if (is_hidden) return null

          return (
            <li
              className={clsx(styles.listItem, {
                [styles.disabled]: is_disable,
              })}
              key={id}
            >
              {is_disable ? (
                <span>{name}</span>
              ) : (
                <Link href={ROUTER_PATHS.catalogCategoryById.get(slug)}>
                  {name}
                </Link>
              )}
            </li>
          )
        })}
      </ul>
      {children.length > visibleSubCategories && (
        <MoreButton
          iconName={isExpanded ? 'chevronRight' : 'chevronLeft'}
          text={isExpanded ? 'Скрыть' : 'Показать больше'}
          onClick={toggleExpand}
        />
      )}
    </div>
  )
}
